import { useMemo } from 'react';

import { getIsTrustWallet } from './getIsTrustWallet';

export const useShouldSwitchNetworkManually = (
  code: string,
  walletName: string | undefined,
  walletType?: string,
): boolean => {
  const isTrustWallet = getIsTrustWallet(walletName);

  const shouldSwitchNetworkManually = useMemo(
    () =>
      (code === 'eth' || code === 'arb') &&
      walletType !== undefined &&
      walletType.toLowerCase().includes('walletconnect') &&
      !isTrustWallet,
    [code, isTrustWallet, walletType],
  );

  return shouldSwitchNetworkManually;
};
